import {s, lazy, filter} from './lang.js';
import {doc} from './documentation.js';

doc(
    "alt",
    {
        "arg1": "",
        "arg2": "",
        "argN": "",
    },
    "Alternates between the arguments with every trigger received by this function"
);

export const alt = (...args) => {
    let counter = 0;
    return (stepData, stepNumber, time) => {
        if (stepData === undefined) {
            return filter(false);
        }

        let _args = args;
        if (_args.length === 1) {
            let lazyEval = lazy(_args[0], stepData, stepNumber, time);
            if (Array.isArray(lazyEval)) {
                _args = lazyEval;
            }
        }
        let index = counter++ % _args.length;
        return lazy(s(_args[index]), stepData, stepNumber, time);
    };
};

// every n triggers alternate outputs, across m-may outputs
doc(
    "altn",
    {
        "n": "How many triggers it takes to increment the output conditional",
        "arg1": "Output conditional",
        "arg2": "Output conditional",
        "argN": "Output conditional (will loop back to arg1 after this this)",
    },
    "Alternates between the arguments every n-many triggers received by this function"
);
export const altn = (n, ... outputs) => {
    let counter = 0;
    let outputNumber = 0;
    return (stepData, stepNumber, time, effect) => {
        let _n = typeof n === "number" ? n : n();
        if (++counter % _n === 0) {
            outputNumber++;
        }
        if (stepData === undefined) {
            return filter(false);
        }
        let output = outputs[outputNumber % outputs.length];
        return lazy(output, stepData, stepNumber, time, effect);
    };
};

doc(
    "every",
    {
        "n": "",
        "action": "",
    },
    "Trigger a given action every n-many triggers"
);

export const every = (n, action) => {
    let counter = 0;
    return (... args) => {
        let _n = lazy(n, ...args);
        let stepData = args[0];
        if (stepData) {
            counter++;
            if (counter % _n === 0) {
                let ret = lazy(action, ...args);
                return ret;
            }
        }
        return filter(true);
    };
};
